function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 18,
  height: 18,
  rx: 2,
  stroke: "#4D4D4D",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 3,
  width: 6,
  height: 8,
  rx: 1,
  stroke: "#4D4D4D",
  strokeWidth: 2
});

function SvgBultos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/bultos.svg";
export { SvgBultos as ReactComponent };